// Slider hero na stronie głównej (Splide).
// Splide zarządza karuzelą (fade, autoplay, dostępność, live region). Strzałki
// i „łączone" bullety trzymamy własne - żeby leżały razem w prawym dolnym rogu -
// i tylko delegujemy do splide.go(). Aktywny bullet aktualizujemy na zdarzeniu.

import Splide from "@splidejs/splide";

export function initHeroSlider() {
  const root = document.querySelector("[data-hero-slider]");
  if (!root) return;

  // Bez animacji przy prefers-reduced-motion - nie odpalamy autoplay.
  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  const splide = new Splide(root, {
    type: "fade",
    rewind: true,
    perPage: 1,
    perMove: 1,
    speed: 700,
    arrows: false, // własne strzałki
    pagination: false, // własne bullety
    autoplay: !prefersReduced,
    interval: 6500,
    pauseOnHover: true,
    pauseOnFocus: true,
    keyboard: "focused",
  });

  const dots = Array.from(root.querySelectorAll("[data-hero-dot]"));
  const prev = root.querySelector("[data-hero-prev]");
  const next = root.querySelector("[data-hero-next]");

  const setActiveDot = (index) => {
    dots.forEach((dot, i) => {
      const active = i === index;
      dot.classList.toggle("is-active", active);
      if (active) dot.setAttribute("aria-current", "true");
      else dot.removeAttribute("aria-current");
    });
  };

  // `move` niesie nowy indeks jeszcze przed końcem animacji - bullet reaguje od razu.
  splide.on("move", (newIndex) => setActiveDot(newIndex));
  splide.on("mounted", () => setActiveDot(splide.index));

  prev?.addEventListener("click", () => splide.go("<"));
  next?.addEventListener("click", () => splide.go(">"));
  dots.forEach((dot, i) => dot.addEventListener("click", () => splide.go(i)));

  splide.mount();
}
